import {
  walletOfferApi,
  type WalletOffersResponse,
  type WalletOffersForProductRequest,
  type WalletOffersForProductResponse,
} from "@b2bportal/wallet-offer-api";
import { createApi, fakeBaseQuery } from "@reduxjs/toolkit/query/react";

import axios from "axios";

export const handleAxiosError = (error: unknown) => {
  if (axios.isAxiosError(error)) {
    const status = error.response?.status || 500;
    const data = error.response?.data || error.message;
    return { type: "network", error: { status, data } };
  }

  return {
    error: { type: "unknown" },
  };
};

export const walletOffersApi = createApi({
  reducerPath: "walletOffers",
  baseQuery: fakeBaseQuery(),
  tagTypes: ["WalletOffers"],
  endpoints: (builder) => ({
    fetchAllWalletOffers: builder.query<WalletOffersResponse, void>({
      queryFn: async () => {
        try {
          const response = await walletOfferApi(axios).apiV0WalletOffersGet();

          return {
            data: response.data,
          };
        } catch (error) {
          return handleAxiosError(error);
        }
      },
      providesTags: ["WalletOffers"],
    }),
    fetchWalletOfferByProduct: builder.query<
      WalletOffersForProductResponse,
      WalletOffersForProductRequest
    >({
      queryFn: async (request) => {
        try {
          const response =
            await walletOfferApi(axios).apiV0WalletOffersForProductPost(
              request
            );

          return { data: response.data };
        } catch (error) {
          return handleAxiosError(error);
        }
      },
    }),
  }),
});
